// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2RYF7","inputDescription":"styles_inputDescription__38Wrp"};